// Fontawesome
import { library, dom } from "@fortawesome/fontawesome-svg-core";
import {
  faSearch,
  faChevronUp,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faBars,
  faAngleLeft,
  faAngleRight,
  faMapMarkerAlt,
  faArrowUp,
  faArrowDown, faKey, faHome, faBuilding, faPhone, faMobileAlt, faFax, faEnvelope, faLink, faBirthdayCake
} from "@fortawesome/free-solid-svg-icons";
library.add(faSearch, faChevronUp, faChevronDown, faChevronLeft, faChevronRight, faBars, faAngleRight, faAngleLeft, faMapMarkerAlt, faArrowUp, faArrowDown, faKey, faHome, faBuilding, faPhone, faMobileAlt, faFax, faEnvelope, faLink, faBirthdayCake);

dom.watch();
